'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

import ErrorBanner from '@/components/ErrorBanner';
import { attemptChunkLoadRecovery } from '@/utils/chunkLoadRecovery';

const ErrorPage = ({ error }) => {
  useEffect(() => {
    // JOYBIRD-40-5QA6 — most chunk failures here are a dropped connection, not a
    // bug. Recover by reloading and skip reporting what the user never saw.
    if (attemptChunkLoadRecovery(error, { origin: 'app-route' })) {
      return;
    }

    // Tagged so this boundary fingerprints apart — see sentry.shared-config.js.
    Sentry.captureException(error, { tags: { errorBoundary: 'app-route' } });
  }, [error]);

  return <ErrorBanner />;
};

export default ErrorPage;
